// Erros do login e da conta (Supabase): nenhum texto em inglês chega à tela. Os erros conhecidos viram frases
// em português pelo código; o resto vira a frase padrão de cada ação.

export const PADRAO_GOOGLE = 'Não deu para entrar com o Google. Tente de novo.';
export const JA_TEM_CONTA = 'identity_already_exists';

export class ErroDaConta extends Error {
  readonly codigo: string | null;
  constructor(mensagem: string, codigo: string | null) { super(mensagem); this.codigo = codigo; }
}

const FORA_DO_AR = 'está fora do ar agora. Tente de novo mais tarde.';
const EXPIROU = 'O login com Google expirou. Tente de novo.';
const SESSAO = 'Sua sessão expirou. Entre de novo.';

const MENSAGENS: Record<string, string> = {
  manual_linking_disabled: 'Guardar a conta com Google ' + FORA_DO_AR,
  identity_already_exists: 'Esse Google já tem conta no Truco de 6.',
  provider_disabled: 'Entrar com Google ' + FORA_DO_AR,
  oauth_provider_not_supported: 'Entrar com Google ' + FORA_DO_AR,
  anonymous_provider_disabled: 'Jogar como convidado ' + FORA_DO_AR,
  signup_disabled: 'Criar conta nova ' + FORA_DO_AR,
  access_denied: 'O Google não liberou a entrada. Tente de novo.',
  over_request_rate_limit: 'Muitas tentativas em pouco tempo. Espere um minuto e tente de novo.',
  request_timeout: 'O login demorou demais. Tente de novo.',
  flow_state_expired: EXPIROU,
  flow_state_not_found: EXPIROU,
  bad_oauth_state: EXPIROU,
  bad_oauth_callback: EXPIROU,
  bad_code_verifier: EXPIROU,
  session_not_found: SESSAO,
  session_expired: SESSAO,
  refresh_token_not_found: SESSAO,
  refresh_token_already_used: SESSAO,
  bad_jwt: SESSAO,
  user_banned: 'Esta conta está bloqueada. Fale com contato@trucode6.com.br.',
  sem_conexao: 'Sem conexão. Confira a internet e tente de novo.',
};

// Mensagem sem código (versões antigas da API, erros de rede): reconhece pelo texto.
const PELO_TEXTO: [RegExp, string][] = [
  [/manual linking is disabled/i, 'manual_linking_disabled'],
  [/identity is already linked|already linked to another user|identity.*already exists/i, 'identity_already_exists'],
  [/provider is not enabled|unsupported provider/i, 'provider_disabled'],
  [/anonymous sign-ins are disabled/i, 'anonymous_provider_disabled'],
  [/rate limit/i, 'over_request_rate_limit'],
  [/failed to fetch|networkerror|load failed|network request failed/i, 'sem_conexao'],
  [/jwt expired|session.*(missing|expired|not found)/i, 'session_expired'],
];

export function codigoDoErro(codigo: string | null | undefined, texto: string | null | undefined): string | null {
  if (codigo && MENSAGENS[codigo]) return codigo;
  for (const [re, c] of PELO_TEXTO) if (texto && re.test(texto)) return c;
  return codigo || null;
}

export function mensagemDoErro(codigo: string | null | undefined, texto: string | null | undefined, padrao = PADRAO_GOOGLE): string {
  const c = codigoDoErro(codigo, texto);
  return (c && MENSAGENS[c]) || padrao;
}

// Erro que volta do Google na URL (?error=&error_code=&error_description=, na query ou no fragmento).
export function erroDaVolta(busca: string, fragmento: string): { codigo: string | null; mensagem: string } | null {
  const q = new URLSearchParams(busca), h = new URLSearchParams(fragmento.replace(/^#/, ''));
  const erro = q.get('error') ?? h.get('error'), codigo = q.get('error_code') ?? h.get('error_code');
  const texto = q.get('error_description') ?? h.get('error_description');
  if (!erro && !codigo && !texto) return null;
  const c = codigoDoErro(codigo || erro, texto);
  return { codigo: c, mensagem: mensagemDoErro(c, texto) };
}
